module.exports = __webpack_public_path__ + "img/dianhua.5f173567.png";